import React from 'react';
import { partnershipStyle as styles } from './partnership.tailwind';

const Partnership = () => {
  return (
    <section className={styles.section_wrapper}>
      <div className={styles.container}>
        {/* Heading */}
        <h2 className={styles.heading}>
          TWO ATLANTA<br className="sm:hidden" /> INSTITUTIONS.<br />
          <span className={styles.highlight}>ONE MISSION.</span>
        </h2>

        {/* Description */}
        <p className={styles.description}>
          A first-of-its-kind sponsorship between the Atlanta Falcons and Children's Healthcare of Atlanta. 
          Built on a shared belief that this city takes care of its own — especially the youngest.
        </p>

        {/* Institutional Boxes */}
        <div className={styles.boxes_container}>
          {/* Falcons Box */}
          <div className={styles.box_falcons}>
            <span className={styles.box_text}>
              ATLANTA<br />FALCONS
            </span>
          </div>

          {/* Red X Symbol */}
          <div className={styles.cross_symbol}>
            &times;
          </div>

          {/* CHOA Box */}
          <div className={styles.box_choa}>
            <span className={styles.box_text}>
              CHILDREN'S HEALTHCARE OF<br />ATLANTA
            </span>
          </div>
        </div>

        {/* Footer info text */}
        <p className={styles.footer_text}>
          REGISTERED 501(C)(3) PARTNER &middot; TOKEN PURCHASES ARE TAX-DEDUCTIBLE
        </p>
      </div>
    </section>
  );
};

export default Partnership;
